import MetadataNameMappings from './metadata-name-mappings.js'

export function getMetadataTypeNamePlural(metadataRepresentationTypeName) {
    if (MetadataNameMappings.metadataNamesMappingPlural.has(metadataRepresentationTypeName)) {
        return MetadataNameMappings.metadataNamesMappingPlural.get(metadataRepresentationTypeName)
    }
    return metadataRepresentationTypeName
}

export function getMetadataTypeNameSingular(metadataRepresentationTypeName) {
    if (MetadataNameMappings.metadataNamesMappingSingular.has(metadataRepresentationTypeName)) {
        return MetadataNameMappings.metadataNamesMappingSingular.get(metadataRepresentationTypeName)
    }
    return metadataRepresentationTypeName
}
